import { OMNISEARCH_CLOSE_MODAL } from '../../constants/actions';

const closeModal = (dispatch, payload) =>
  dispatch({
    type: OMNISEARCH_CLOSE_MODAL,
    payload,
  });

export default (dispatch) => () => closeModal(dispatch, { open: false });
